import { render, staticRenderFns } from "./create-location-bar.vue?vue&type=template&id=1526d3ab&scoped=true"
import script from "./create-location-bar.vue?vue&type=script&lang=ts"
export * from "./create-location-bar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1526d3ab",
  null
  
)

export default component.exports